import { useLocation } from 'react-router';
import { ReactNode, useMemo } from 'react';

import { isSSG } from 'modules/common/utils/isSSG';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useBreadcrumbs } from 'modules/layout/components/BreadcrumbsProvider';
import { useOnMount } from 'modules/common/hooks/useOnMount';

import { isInvitation } from './utils/isInvitation';
import { ConnectWalletCard } from '../ConnectWalletCard';
import { isEmailChange } from './utils/isEmailChange';

interface IAuthUserSettingsGuardProps {
  children?: ReactNode;
}

export const AuthUserSettingsGuard = ({
  children,
}: IAuthUserSettingsGuardProps) => {
  const location = useLocation();

  const { isLoggedIn } = useAuth();

  const { setBreadcrumbs } = useBreadcrumbs();

  const hasInvitation = useMemo(
    () => !isSSG() && isInvitation(location),
    [location],
  );

  const isEmailConfirmation = useMemo(
    () => !isSSG() && isEmailChange(location),
    [location],
  );

  useOnMount(() => {
    if (!isLoggedIn) {
      setBreadcrumbs([]);
    }
  });

  if (isLoggedIn || hasInvitation || isEmailConfirmation) {
    return <>{children}</>;
  }

  return <ConnectWalletCard />;
};
